import React from "react";
import { Link } from "react-router-dom";
import { createPageUrl } from "../utils";
import { ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";

/**
 * DATA GALLERY
 * simpan gambar di: public/images/gallery/
 */
const galleries = [
  {
    id: 1,
    title: "Desa Export",
    image: "/images/gallery/web1.png",
    category: "Website",
    url: "https://desaexport.id",
  },
  {
    id: 2,
    title: "Swadayatridaya",
    image: "/images/gallery/app1.png",
    category: "Mobile App",
    url: "https://swadayatridaya.com",
  },
  {
    id: 3,
    title: "Pasompe, Jatim",
    image: "/images/gallery/dashboard1.png",
    category: "System",
    url: "https://pas-jatim.ghandiva-appsite.biz.id",
  },
   {
    id: 4,
    title: "Beauty Luxury",
    image: "/images/gallery/4.png",
    category: "Website",
    url: "https://beauty-luxury.ghandiva-appsite.biz.id/",
  },
  {
    id: 5,
    title: "PT Antarkan Saja",
    image: "/images/gallery/5.png",
    category: "Website",
    url: "https://antarkan-saja.ghandiva-appsite.biz.id/",
  },
  {
    id: 6,
    title: "PT Sand TEKNIK",
    image: "/images/gallery/6.png",
    category: "Website",
    url: "https://pt-sand-teknik.ghandiva-appsite.biz.id/",
  },
  {
    id: 7,
    title: "Ritel 100 jam",
    image: "/images/gallery/7.png",
    category: "Website",
    url: "https://ritel100jam.ghandiva-appsite.biz.id/",
  },
  {
    id: 8,
    title: "Kapal-In",
    image: "/images/gallery/kapal-in.png",
    category: "Website",
    url: "https://kapal-in.ghandiva-appsite.biz.id",
  },
  {
    id: 9,
    title: "Ketemu Kopi",
    image: "/images/gallery/ketemu-kopi.png",
    category: "Website",
    url: "https://ketemu-kopi.ghandiva-appsite.biz.id",
  },
  {
    id: 10,
    title: "Pusat Bumbu",
    image: "/images/gallery/pusat-bumbu.png",
    category: "Website",
    url: "https://pusat-bumbu.ghandiva-appsite.biz.id",
  },
  {
    id: 11,
    title: "Scent Kissed",
    image: "/images/gallery/scent-kissed.png",
    category: "Website",
    url: "https://scent-kissed.ghandiva-appsite.biz.id",
  },
  {
    id: 12,
    title: "Singgahin Yuk",
    image: "/images/gallery/singgahinyuk.png",
    category: "Website",
    url: "https://singgahinyuk.ghandiva-appsite.biz.id",
  },
  {
    id: 13,
    title: "Toko Mitra Tjandra",
    image: "/images/gallery/toko-mitra-tjandra.png",
    category: "Website",
    url: "https://toko-mitra-tjandra.ghandiva-appsite.biz.id",
  },
  {
    id: 14,
    title: "Yutakachi",
    image: "/images/gallery/yutakachi.png",
    category: "Website",
    url: "https://yutakachi.ghandiva-appsite.biz.id",
  },
];


export default function Gallery() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <section className="pt-28 pb-20 bg-gradient-to-br from-gray-50 via-white to-gray-100">
        <div className="container mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            Portofolio <span className="text-gray-700">Galeri</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Kumpulan proyek terbaik Ghandiva dalam membangun solusi digital
            modern untuk berbagai kebutuhan bisnis.
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20">
        <div className="container mx-auto px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
           {galleries.map((item) => (
  <a
    key={item.id}
    href={item.url}
    target="_blank"
    rel="noopener noreferrer"
    className="group relative overflow-hidden rounded-3xl bg-white shadow-md hover:shadow-2xl transition-all duration-300"
  >
    <img
      src={item.image}
      alt={item.title}
      className="w-full h-72 object-cover group-hover:scale-110 transition-transform duration-700"
    />

    {/* Overlay */}
    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300 flex items-end">
      <div className="p-6">
        <span className="inline-block mb-2 text-xs tracking-widest uppercase text-gray-300">
          {item.category}
        </span>
        <h3 className="text-xl font-semibold text-white">
          {item.title}
        </h3>
        <p className="text-sm text-gray-300 mt-1">
          Klik untuk buka website →
        </p>
      </div>
    </div>
  </a>
))}

          </div>

          {/* CTA */}
          <div className="flex justify-center mt-16">
            <Link to={createPageUrl("Contact")}>
              <Button
                size="lg"
                className="px-8 py-4 bg-gray-700 hover:bg-gray-800 text-white flex items-center group shadow-lg"
              >
                Diskusikan Proyek Anda
                <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
